import {
  Dialog,
  DialogContent,
  IconButton,
  Tabs,
  Tab,
  Box,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import CustomTypography from "../../../components/common/form/CustomTypography";

interface OpsSyncInstructionPopupProps {
  open: boolean;
  onClose: () => void;
  additionalData: string;
}

const OpsSyncInstructionPopup: React.FC<OpsSyncInstructionPopupProps> = ({
  open,
  onClose,
  additionalData,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ px: 3, pt: 2, pb: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <CustomTypography variant="heading4">Instructions</CustomTypography>
          <IconButton onClick={onClose}>
            <CloseIcon
              sx={{
                fontSize: 20,
                color: theme?.palette?.customColors?.blackBorder,
              }}
            />
          </IconButton>
        </Box>

        <Tabs
          value={activeTab}
          onChange={(e, val) => setActiveTab(val)}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            ".MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.875rem",
              color: theme?.palette?.customColors?.greyTextColor,
            },
            ".Mui-selected": {
              color: theme?.palette?.purple?.main,
            },
            ".MuiTabs-indicator": {
              backgroundColor: theme?.palette?.purple?.main,
            },
          }}
        >
          <Tab label="Order notes" />
          {/* <Tab label="Project Ops notes" /> */}
        </Tabs>
      </Box>

      <DialogContent>
        {activeTab === 0 && (
          <Box
            sx={{
              backgroundColor: theme?.palette?.customColors?.greyBodyBackground,
              p: 2,
              borderRadius: 2,
              marginBottom: 3,
              "& p": {
                margin: "0.5em 0",
                "&:first-of-type": { marginTop: 0 },
                "&:last-of-type": { marginBottom: 0 },
              },
              "& strong": {
                fontWeight: 600,
              },
            }}
          >
            <Box
              sx={{
                lineHeight: 1.7,
                whiteSpace: "pre-line",
                fontSize: "0.875rem",
                fontFamily: theme?.typography?.fontFamily,
                color: theme?.palette?.customColors?.greyTextColor,
                display: "block",
                minHeight: "20px",
              }}
              dangerouslySetInnerHTML={{
                __html: additionalData || "No additional information available",
              }}
            />
          </Box>
        )}

        {/* {activeTab === 1 && (
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {data?.project_ops_notes}
          </Typography>
        )} */}
      </DialogContent>
    </Dialog>
  );
};

export default OpsSyncInstructionPopup;
